import { trpc } from '@tencent/tpro_rmonitor_web_server_network_http';
import { get } from 'lodash-es';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IGetErrURLListReq = WithTypeCast<trpc.rmonitor.web_server.IGetErrURLListReq>;
export type IGetErrURLListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetErrURLListRsp>;
export type IProblemInfo = WithTypeCast<trpc.rmonitor.web_server.GetIssueListRsp.IProblemInfo>;
export type IErrURLInfo = WithTypeCast<trpc.rmonitor.web_server.GetErrURLListRsp.IErrURLInfo>;
export type IGetIssueListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetIssueListRsp>;
export type IDimensionalGroups = WithTypeCast<trpc.rmonitor.web_server.IDimensionalGroups>;
export type IGetMultiDimensionalGroupsReq = WithTypeCast<trpc.rmonitor.web_server.IGetMultiDimensionalGroupsReq>;
export type IGetIssueListReq = WithTypeCast<trpc.rmonitor.web_server.IGetIssueListReq>;
export type IGetReportListReq = WithTypeCast<trpc.rmonitor.web_server.IGetReportListReq>;
export type IGetReportListRsp = WithTypeCast<trpc.rmonitor.web_server.IGetReportListRsp>;
export type IAccounts = WithTypeCast<trpc.rmonitor.web_server.GetReportListRsp.IAccounts>;
export type IGetDetailReq = WithTypeCast<trpc.rmonitor.web_server.IGetDetailReq>;
export type IGetDetailRsp = WithTypeCast<trpc.rmonitor.web_server.IGetDetailRsp>;
export type IProblemDetail = WithTypeCast<trpc.rmonitor.web_server.GetDetailRsp.IProblemDetail>;
export type IGetDomainStatsReq = WithTypeCast<trpc.rmonitor.web_server.IGetDomainStatsReq>;
export type IGetDomainStatsRsp = WithTypeCast<trpc.rmonitor.web_server.IGetDomainStatsRsp>;

/**
 * 产品成员管理
 */
export class NetHttpService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.NetHttpService,
    });
  }

  /**
   * 获取多维分组
   * @param req
   */
  public async getMultiDimensionalGroups(req: IGetMultiDimensionalGroupsReq): Promise<IDimensionalGroups[]> {
    try {
      const res = await this.trpcPost('GetMultiDimensionalGroups', req);
      return get(res, 'groups', []);
    } catch (e) {
      console.log('getMultiDimensionalGroups', e);
      return [];
    }
  }

  public async getIssueList(req: IGetIssueListReq): Promise<IGetIssueListRsp> {
    try {
      return await this.trpcPost('GetIssueList', req);
    } catch (e) {
      return {
        topCaseRatio: 0,
        data: [],
        totalIssueCount: 0,
        topIssueCount: 0,
      };
    }
  }

  public async getReportList(req: IGetReportListReq): Promise<IGetReportListRsp> {
    try {
      return await this.trpcPost('GetReportList', req);
    } catch (e) {
      return {
        accounts: [],
      };
    }
  }

  public async getDetail(req: IGetDetailReq): Promise<IGetDetailRsp> {
    try {
      return await this.trpcPost('GetDetail', req);
    } catch (e) {
      return {
        problemDetail: null,
      };
    }
  }

  public async getErrURLList(req: IGetErrURLListReq): Promise<IGetErrURLListRsp> {
    try {
      return await this.trpcPost('GetErrURLList', req);
    } catch (e) {
      return {
        totalDocCount: 0,
        data: [],
        totalQimeiCount: 0,
        totalAccountCount: 0,
      };
    }
  }

  /** 获取域名统计（最近30天上报量 + 归属） */
  public async getDomainStats(req: IGetDomainStatsReq): Promise<IGetDomainStatsRsp> {
    try {
      return await this.trpcPost<IGetDomainStatsRsp>('GetDomainStats', req);
    } catch (e) {
      console.log('getDomainStats', e);
      return {};
    }
  }
}

export const netHttpService = new NetHttpService();
